import DeviceConfig from '@devices/config';
import { disable, enable } from '@shared/store/slices/magicRemote.slice';
import { useAppDispatch } from '@shared/store/hooks';
import { useEffect } from 'react';

// Magic remote management

export default function useMagicRemote() {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (DeviceConfig.capabilities.magicRemote) {
      document.addEventListener('mousemove', () => {
        dispatch(enable());
      });
      document.addEventListener('keydown', () => {
        setTimeout(() => dispatch(disable()));
      });
    }
  }, []);

  return null;
}
